// Thrown by getValidAccessToken() when a token could not be obtained for a
// reason that says nothing about the session itself: network down, auth
// service 5xx, throttling. Callers must NOT treat it as "signed out" — the
// request that needed the token fails, the session stays.
//
// Checked by name rather than `instanceof` (subclassing Error is unreliable
// once transpiled to ES5).
export class AuthTransientError extends Error {
    constructor(cause) {
        super(`Transient authentication error: ${cause?.message || cause}`);
        this.name = 'AuthTransientError';
        this.cause = cause;
    }
}

export const isAuthTransientError = (error) => error?.name === 'AuthTransientError';
